/// <amd-module name="Widgets/VelocityWidget/VelocityWidgetComponents/VelocityActionCreator" />
import { ActionCreatorBase } from "WidgetCommon/ModernWidgetTypes/ActionCreatorBase";

export class VelocityActionCreator extends ActionCreatorBase {}
